import { FAST_FORM_SHAPE_FIELD_KEYS } from '../data/constants';

const filterObjectByKeys = (
	form: any,
	disallowed = FAST_FORM_SHAPE_FIELD_KEYS,
) => {
	const filtered = Object.keys(form)
		.filter((key) => !disallowed.includes(key))
		.reduce((obj: any, key) => {
			const currForm = form;
			obj[key] = currForm[key];
			return obj;
		}, {});
	return filtered;
};

export default filterObjectByKeys;
